import { render } from "./ProductDetailStockTab.vue?vue&type=template&id=97e0a2b0&ts=true"
import script from "./ProductDetailStockTab.vue?vue&type=script&lang=ts"
export * from "./ProductDetailStockTab.vue?vue&type=script&lang=ts"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__